<template>
  <h1 class="home">이 페이지는 babylonjs의 기능을 학습한 기록입니다.</h1>
</template>

<script>
// @ is an alias to /src
export default {
  name: "Home",

  metaInfo() {
    return {
      title: "SEO Test | babylonjs Study",
      meta: [
        {
          vmid: "description",
          name: "description",
          content: "이 페이지는 babylonjs의 기능을 학습한 기록입니다.",
        },
      ],
    };
  },
};
</script>
